"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const native_base_1 = require("native-base");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const user_1 = require("../../store/selectors/user");
const colors_1 = require("../../common/colors");
const theme_1 = require("../../helper/theme");
const Loader_1 = require("../CharacterList/Loader");
const ChatHtmlText_1 = __importDefault(require("./ChatHtmlText"));
const AppText_1 = require("../AppText");
/**
 *
 * @param param0
 * @returns
 */
const ChatText = ({ message, isLoading, isLastMsg, onTypeComplete, }) => {
    const convesation = (0, react_redux_1.useSelector)(user_1.selectConversation);
    const getTextStyle = (0, react_1.useMemo)(() => ({
        color: colors_1.Colors.white,
        fontSize: (0, theme_1.normalize)(16),
        lineHeight: (0, theme_1.normalize)(20),
    }), []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(native_base_1.Stack, { children: [isLastMsg ? ((0, jsx_runtime_1.jsx)(native_base_1.View, { paddingX: 3, paddingY: 2, children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { paddingX: 3, paddingY: 2, style: getTextStyle, selectable: true, children: message.message }) })) : react_native_1.Platform.OS === "ios" ? ((0, jsx_runtime_1.jsx)(ChatHtmlText_1.default, { message: message.message, type: "system" })) : ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: getTextStyle, selectable: true, children: message.message })), isLoading && ((0, jsx_runtime_1.jsx)(native_base_1.View, { paddingX: 3, children: (0, jsx_runtime_1.jsx)(Loader_1.ChatMsgLoader, {}) }))] }) }));
};
exports.default = (0, react_1.memo)(ChatText);
